import { useContext } from 'react'

import { useGetIsMobile } from 'hooks/useGetIsMobile'
import { useScreenSize } from 'hooks/useScreenSize'
import { AppContext } from 'state/appContext'

export const useIsMobile = () => {
  const {
    state: { isMobileSsr },
  } = useContext(AppContext)

  const { isMobile: isMobileCsr } = useScreenSize()

  const isMobile = useGetIsMobile(isMobileSsr, isMobileCsr)
  return isMobile
}
